var _path, _path2, _ellipse, _path3, _ellipse2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 141,
    viewBox: "0 0 152 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.749 15.2236H27.9028V75.1341H122.749V15.2236Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.114 19.6074H30.5371V72.2118H120.114V19.6074Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.4025,
    cy: 14.3176,
    rx: 13.173,
    ry: 13.3176,
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4025 27.6351C89.1273 27.6351 83.2295 21.6726 83.2295 14.3176C83.2295 6.96247 89.1273 1 96.4025 1",
    stroke: "#FFE600",
    strokeWidth: 1.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.4027,
    cy: 14.3176,
    rx: 10.5384,
    ry: 10.654,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.519 12.3013H28.1597V16.749H122.519V12.3013Z",
    fill: "#FFE600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.14 15.1829C31.5503 15.1829 31.883 14.8138 31.883 14.3585C31.883 13.9033 31.5503 13.5342 31.14 13.5342C30.7296 13.5342 30.397 13.9033 30.397 14.3585C30.397 14.8138 30.7296 15.1829 31.14 15.1829Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9583 15.1829C34.3687 15.1829 34.7013 14.8138 34.7013 14.3585C34.7013 13.9033 34.3687 13.5342 33.9583 13.5342C33.548 13.5342 33.2153 13.9033 33.2153 14.3585C33.2153 14.8138 33.548 15.1829 33.9583 15.1829Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7796 15.1829C37.19 15.1829 37.5226 14.8138 37.5226 14.3585C37.5226 13.9033 37.19 13.5342 36.7796 13.5342C36.3693 13.5342 36.0366 13.9033 36.0366 14.3585C36.0366 14.8138 36.3693 15.1829 36.7796 15.1829Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140.407 110.35C140.657 109.386 141.085 108.564 141.594 107.977L143.443 98.627L147.473 99.7222L145.163 109.089C145.315 109.882 145.285 110.828 145.035 111.792C144.465 113.995 142.967 115.458 141.689 115.06C140.411 114.662 139.837 112.553 140.407 110.35H140.407Z",
    fill: "#FFB6B6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.965 49.0157C140.965 49.0157 145.318 48.849 147.841 51.9972C150.731 55.9138 152.707 71.2599 151.224 72.2933L147.206 103.945L141.475 103.072L142.946 65.0942L140.965 49.0157V49.0157Z",
    fill: "#FFE600"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M111.576 102.369L112.618 141H127.598L128.203 126.109L130.865 141H146.919L144.916 115.401L142.848 110.018L141.448 106.369L111.576 102.369Z",
    fill: "#2F2E41"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M123.473 42.7055L133.879 42.0059L137.348 46.9031C140.344 47.6147 143.05 48.5333 144.916 50.0513C144.47 64.7171 145.451 83.7869 141.448 87.4803L145.002 115.312C145.002 115.312 143.569 113.949 141.174 114.43C140.347 114.596 139.348 116.664 138.332 116.789C130.521 117.751 117.854 116.762 111.576 102.369L114.012 81.5336L113.382 51.1007C115.353 49.3719 117.805 48.2484 120.635 47.6027L123.473 42.7055V42.7055H123.473Z",
    fill: "#FFE600"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.439 34.1914C103.326 35.4042 103.47 36.5447 103.8 37.4591L102.066 48.9368L107.014 49.692L108.24 37.9677C108.731 37.1475 109.082 36.0636 109.195 34.8508C109.453 32.0803 108.373 29.6867 106.784 29.5047C105.195 29.3226 103.697 31.4209 103.439 34.1914V34.1914H103.439H103.439Z",
    fill: "#FFB6B6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.888 51.9776C120.406 52.8255 120.262 53.7785 120.386 54.9235C120.911 59.7845 112.513 74.1487 106.703 75.8026C105.94 76.0196 105.506 76.9319 104.736 77.1154H104.736C102.456 77.659 100.334 75.6517 100.457 73.0686L102.035 39.9395L108.666 42.4483L108.242 59.6483C108.284 56.085 111.233 52.4568 113.468 50.9478C113.468 50.9478 117.993 48.8762 119.888 51.9776L119.888 51.9776Z",
    fill: "#FFE600"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M127.596 41.1006C122.534 41.1006 118.43 36.5483 118.43 30.9326C118.43 25.317 122.534 20.7646 127.596 20.7646C132.659 20.7646 136.763 25.317 136.763 30.9326C136.763 36.5483 132.659 41.1006 127.596 41.1006Z",
    fill: "#FFB6B6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.058 23.4662C119.137 23.4872 117.851 22.0974 117.797 22.067C116.535 21.3674 117.831 28.206 118.743 28.0136C120.985 27.5414 121.953 26.6039 122.823 28.9441C123.066 29.5947 123.218 30.3293 123.691 30.7946C124.34 31.4277 125.419 31.3752 125.948 32.1308C126.374 32.7395 126.251 33.635 125.936 34.3206C125.62 35.0097 125.141 35.5939 124.854 36.297C124.533 37.0875 125.904 39.6026 126.428 41.0158V41.0193L126.431 41.0276C126.57 41.3983 126.901 40.3305 127.25 40.2239C127.667 40.0963 128.282 41.1901 128.947 40.9913C128.951 40.9913 128.954 40.9878 128.957 40.9878C129.591 40.7919 130.297 40.5821 130.997 40.3722H131C132.971 39.7775 133.47 40.631 133.564 40.6065L134.788 39.1863C135.208 38.8472 135.16 37.7524 135.456 37.4583C135.698 37.2178 136.302 37.7735 136.48 37.5424C137.352 36.409 137.553 35.2752 138.067 33.0368C138.537 30.9905 139.512 24.8654 137.509 24.5891C135.62 24.3267 137.001 21.4094 135.1 21.5178C135.213 20.9861 135.002 20.4159 134.658 20.0241C134.318 19.6289 133.864 19.384 133.406 19.1741C131.152 18.1527 131.527 17.2747 129.149 17.8694C128.913 17.5021 125.88 16.5445 125.451 16.667C125.42 16.674 126.112 18.1667 124.419 17.8694C124.482 18.2996 123.559 17.3666 123.473 18.9188C121.667 17.7164 120.695 20.5943 120.635 21.0176C120.556 21.5458 121.275 21.2764 120.796 21.3569C120.512 21.4059 120.026 22.046 120.074 22.3643C119.869 22.0565 119.664 21.7522 119.455 21.4443C119.418 21.4478 119.383 21.4548 119.345 21.4618C118.386 21.6647 119.485 25.141 119.446 24.0574C119.373 22.067 118.103 23.2318 119.058 23.4662H119.058Z",
    fill: "#2F2E41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18858 48.0551C1.11922 48.0307 1.04983 48.0027 0.980462 47.9712C1.06875 48.0412 1.1539 48.1076 1.24219 48.1776L1.18859 48.0551H1.18858Z",
    fill: "#2F2E41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.123,
    y: 37.1426,
    width: 28.9807,
    height: 2.92246,
    rx: 1.46123,
    fill: "#E6E6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.123,
    y: 37.1426,
    width: 11.8557,
    height: 2.92246,
    rx: 1.46123,
    fill: "#FFE600"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.123,
    y: 44.4487,
    width: 28.9807,
    height: 2.92246,
    rx: 1.46123,
    fill: "#E6E6E6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.123,
    y: 44.4487,
    width: 7.90382,
    height: 2.92246,
    rx: 1.46123,
    fill: "#FFE600"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37.123,
    y: 51.7549,
    width: 28.9807,
    height: 2.92246,
    rx: 1.46123,
    fill: "#E6E6E6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37.123,
    y: 51.7549,
    width: 25.0288,
    height: 2.92246,
    rx: 1.46123,
    fill: "#FFE600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.7aead569a900a1b7626114c26c844708.svg";
export { ForwardRef as ReactComponent };